/**
 * YugOS brand mark — the single source of truth for the logo image across
 * the app. Use this everywhere instead of the old placeholder "Y" chips so
 * that a future logo swap is a one-line change.
 *
 * `size` is the rendered pixel box (square). The image itself is a PNG with
 * a transparent background so it drops onto light and dark surfaces cleanly.
 *
 *   <Logo size={28} />                     — default
 *   <Logo size={40} withWordmark />        — mark + "YugOS" text
 *   <Logo size={40} withWordmark tone="dark" />  — for dark surfaces
 */
import React from "react";

export function Logo({
    size = 28,
    withWordmark = false,
    tone = "light",
    className = "",
    wordmarkClassName = "",
    ...rest
}) {
    const wordmarkColor = tone === "dark" ? "text-white" : "text-zinc-950";
    return (
        <span
            className={`inline-flex items-center gap-2 ${className}`}
            {...rest}
        >
            <img
                src="/brand/yugos-logo.png"
                alt="YugOS"
                width={size}
                height={size}
                draggable={false}
                className="select-none shrink-0"
                style={{ width: size, height: size }}
            />
            {withWordmark && (
                <span
                    className={`font-display font-semibold tracking-tight ${wordmarkColor} ${wordmarkClassName}`}
                >
                    YugOS
                </span>
            )}
        </span>
    );
}

export default Logo;
